import { startGame } from '@fg/base/main';
import { Scene } from '@fg/base/scene';
import store from '@fg/base/store';

let coinsAnim;
let batAnim;

class GameScene extends Scene {
    update()
    {
        super.update();
    }

    init()
    {
        super.init();

        this.mainSound = this.sound.add('mus_general', {"loop":true});
        this.mainAmbSound = this.sound.add('amb_main', {"loop":true});
        this.mainAmbSound.play();
        this.mainSound.play();

        store.commit('toggleExplanation', {
            callback: () => {
                this.letInitialize(() => {
                    this.prepareSounds();
                    this.properties();
                    this.positionerContainer = this.add.container();
                    this.createBg();
                    this.createBonus();
                    this.mainGameGroup = this.add.container();
                    this.frontContainer = this.add.container();
                    this.createGameItems();
                    this.createMultiplier();
                    this.createFader();
                    this.createLightnings();
                    this.createCoinsBurster();
                    this.createOtherAnimations();
                    this.spritesReady = true;
                    this.baseGamePositioner();
                    this.canvasReady();
                });
            }
        });
    }

    prepareSounds()
    {
        this.bonusSound = this.sound.add('mus_bonus', {"loop":true, "volume": 0});
        this.bonusSoundAmb = this.sound.add('amb_bonus', {"loop":true, "volume": 0});
        this.pointCountSound = this.sound.add('sfx_big_win_counter_loop', {"loop":true, "volume": 1});

        this.batsSound = this.sound.add('sfx_big_win_bats');
        this.stgBigWin = this.sound.add('stg_bigwin');
    }

    beforePurchase()
    {
        this.sound.play('sfx_click_play');
    }

    afterPurchase()
    {
        this.symbolsOpened = 0;
        this.bonusSymbolsOpened = 0;
        this.bonusRunning = false;
        this.winAllRunning = false;
        this.allNeededBonusItemsOpened = false;
        this.multiplierFinished = false;
        this.mappedLuckies = {};
        this.openedYourSymbolsLucky = [];
        this.yourSymbolsOpeningSequence = [];
        this.bonusTweens = [];
        this.bonusItem = false;
        this.bonusWin = 0;

        this.afterPurchaseAnimation();
    }

    afterPurchaseAnimation()
    {
        this.tweens.add({
            targets: [this.mainSound, this.mainAmbSound],
            volume: 0.5,
            duration: 1000,
        });

        if (this.request.gamePlayedTimes > 0) {
            this.resetGame(() => {
                this.loadSymbols(() => {
                    store.commit('showOpenAllButton');
                });
            });
        } else {
            this.loadSymbols(() => {
                store.commit('showOpenAllButton');
            });
        }
    }

    resetGame(callback)
    {
        this.sound.play('sfx_lucky_symbols_hide');

        for (let i = 0; i < 4; i++) {
            let item = this.mainGameItems['lucky_symbols'][i];
            item.opened = false;

            item.play(`gold_close_${item.lastOpenedAs}`);

            item.lastOpenedAs = false;
        }

        for (let i = 0; i < 16; i++) {
            let item = this.mainGameItems['your_symbols'][i];
            item.setAlpha(1);
            item.opened = false;
            item.amount_after = 0;

            if (item.amount) {
                item.amount.destroy();
            }

            item.greyItem.setAlpha(0);

            if (item.lastOpenedAs === 'bonus_symbol') {
                item.play(`bonus_close`);
            } else {
                item.play(`stone_close_${item.lastOpenedAs}`);
            }

            item.mouseOverSprite = this.add.sprite(item.x, item.y + 10, 'symbol_hover').setAlpha(0).setAngle(item.angle);
            this.mainGameGroup.add(item.mouseOverSprite);

            item.lastOpenedAs = false;
        }

        for (let i = 0; i < 10; i++) {
            let item = this.bonusItems[i];
            item.opened = false;

            item.setAlpha(1).setTexture('pumpkin_smash').setFrame('Pumpkin_Smash_0000.png');

            if (item.amount) {
                item.amount.destroy();
            }
        }

        if (this.winAllTempSymbol) {
            this.winAllTempSymbol.destroy();
        }

        this.jackpotSlotOpen.playReverse('jackpot_slot_open');

        this.jackpotSlotOpen.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
            this.jackpotIndicator.setTexture('');
            this.jackpotIndicatorAfter.setAlpha(0);
            callback();
        });
    }

    loadSymbols(callback)
    {
        this.jackpotIndicator.setTexture(`jackpot_indicator_${this.request.scenario.win_all_bonus.symbol}`);
        this.jackpotIndicator.play(`jackpot_indicator_${this.request.scenario.win_all_bonus.symbol}`);

        for (let i = 0; i < this.request.scenario.lucky_symbols.length; i++) {
            this.mappedLuckies[this.request.scenario.lucky_symbols[i]] = this.mainGameItems['lucky_symbols'][i];
        }

        this.tweens.add({
            targets: this.fullFaderMain,
            alpha: 0,
            ease: 'Power0',
            duration: 500,
            onComplete: () => {
                let delay = 0;
                let delayStep = 100;

                this.time.delayedCall(delay, () => {
                    this.sound.play('sfx_lucky_symbols_reveal');

                    for (let i = 0; i < 4; i++) {
                        this.flipUpSymbol(this.mainGameItems['lucky_symbols'][i], this.request.scenario.lucky_symbols[i], 'gold', (i * delayStep));
                        this.mainGameItems['lucky_symbols'][i].lastOpenedAs = this.request.scenario.lucky_symbols[i];
                    }

                    this.time.delayedCall(500, () => {
                        this.jackpotSlotOpen.play('jackpot_slot_open');
                    });

                    this.time.delayedCall(100, () => {
                        this.jackpotSlotOpen.play('jackpot_slot_open');
                        this.showGameMultiplier(() => {
                            for (let i = 0; i < 16; i++) {
                                let item = this.mainGameItems['your_symbols'][i];
                                this.addItemInputs(item, i);
                                if (i === 15) {
                                    callback();

                                    this.enableIdleTimer();
                                }
                            }
                        });
                    });
                });
            }
        });
    }

    addItemInputs(item, index)
    {
        item.setInteractive({ cursor: 'pointer', pixelPerfect: true})
            .on('pointerup', () => {
                this.openYourSymbol(index, item);
            })
            .on('pointerover', () => {
                if (!item.mouseOverSprite) {
                    return;
                }

                this.sound.play('sfx_cards_single_hover');

                if (item.mouseOverSprite.tween && item.mouseOverSprite.tween.isPlaying()) {
                    item.mouseOverSprite.tween.stop();
                }

                if (!item.opened) {
                    item.mouseOverSprite.tween = this.tweens.add({
                        targets: item.mouseOverSprite,
                        alpha: 1,
                        duration: 100,
                        ease: 'Power0'
                    });
                }
            })
            .on('pointerout', () => {
                if (!item.mouseOverSprite) {
                    return;
                }

                if (item.mouseOverSprite.tween && item.mouseOverSprite.tween.isPlaying()) {
                    item.mouseOverSprite.tween.stop();
                }
                if (!item.opened) {
                    item.mouseOverSprite.tween = this.tweens.add({
                        targets: item.mouseOverSprite,
                        alpha: 0,
                        duration: 100,
                        ease: 'Power0'
                    });
                }
            });
    }

    showGameMultiplier(callback)
    {
        this.sound.play('sfx_cauldron_explosion');

        this.couldronReveal.play('couldron_reveal_fx');
        this.multiplier.setTexture(`multiplier_x${this.request.scenario.multiplier}`);
        this.multiplier.play(`multiplier_x${this.request.scenario.multiplier}`);

        this.couldronReveal.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
            callback();
        });
    }

    flipUpSymbol(item, symbol, color, delay, callback)
    {
        this.time.delayedCall(delay, () => {
            if (symbol === 'bonus_all_symbol') {
                symbol = this.request.scenario.win_all_bonus.symbol;
            }

            let key = `${color}_open_${symbol}`;

            if (symbol === 'bonus_symbol') {
                key = 'bonus_open';
            }

            item.play(key);

            item.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                if (callback) {
                    callback();
                }
            });
        });
    }

    openYourSymbol(i, item, openingAll)
    {
        if (item.opened || this.bonusRunning || this.winAllRunning) {
            return;
        }

        if (!openingAll) {
            this.sound.play('sfx_cards_row_reveal');
        }

        item.opened = true;
        this.resetIdleTimer();
        this.customHelper.removeClickable(item, () => {
            this.stopItemIdle(item);
        });

        const scenarioItem = this.request.scenario.your_symbols[this.symbolsOpened];
        let flipColor = 'stone';

        if (scenarioItem === 'bonus_symbol') {
            this.bonusRunning = true;
            this.request.reportEvent('bonus_start');
            this.sound.play('sfx_bonus_symbol');
        } else if (scenarioItem === 'bonus_all_symbol') {
            this.winAllRunning = true;
            flipColor = 'stone';
        }

        const symbolOpenedAs = this.symbolsOpened;

        this.yourSymbolsOpeningSequence.push({onScenario:this.symbolsOpened, onBoard:i});

        item.lastOpenedAs = scenarioItem.symbol ? scenarioItem.symbol : scenarioItem;

        this.time.delayedCall(0, () => {
            item.mouseOverSprite.destroy(); //workaround if mouseover not hidden
        });

        this.flipUpSymbol(item, scenarioItem.symbol ? scenarioItem.symbol : scenarioItem, flipColor, 0, () => {
            if (scenarioItem === 'bonus_symbol') {
                item.play('bonus_win');
                this.bonusItem = item;

                store.commit('disableOpenAllButton');
                item.amount = this.add.sprite(item.x, item.multiplierSprite.y, 'bonus_text').setScale(0).setAngle(item.angle);
                this.mainGameGroup.add(item.amount);

                item.tween = this.tweens.add({
                    targets: [item.amount],
                    scale: 0.6,
                    duration: 500,
                    ease: Phaser.Math.Easing.Back.Out,
                });

                this.time.delayedCall(1500, () => {
                    this.showBonus();
                });
            } else if (scenarioItem === 'bonus_all_symbol') {
                store.commit('disableOpenAllButton');
                item.lastOpenedAs = this.request.scenario.win_all_bonus.symbol;
                this.runWinAll(item);
            } else {
                if (scenarioItem.win) {
                    this.shootLightningFromTo(
                        this.mappedLuckies[scenarioItem.symbol].x,
                        this.mappedLuckies[scenarioItem.symbol].y,
                        item.x,
                        item.y
                    );

                    this.sound.play('sfx_thunder_small');

                    item.fronEffect.play('win_fx');
                    this.mappedLuckies[scenarioItem.symbol].play(`win_${scenarioItem.symbol}`);
                    this.burstCoins(item.x + this.mainGameGroup.x, item.y + this.mainGameGroup.y);
                    item.play(`win_${scenarioItem.symbol}`);

                    this.sound.play('sfx_win_symbol_' + this.mappedSymbolsNames[scenarioItem.symbol]);

                    this.openedYourSymbolsLucky.push(item);

                    if (scenarioItem.amount_after) {
                        item.amount_after = General.format_currency(scenarioItem.amount_after).replace(Config.currency.symbol, '');

                        item.amount_add_to_won = scenarioItem.amount_after - scenarioItem.amount;
                    }
                }

                const amount = General.format_currency(scenarioItem.amount).replace(Config.currency.symbol, '');

                item.amount = this.customHelper
                    .createWinningFromSprites(amount, 1, (scenarioItem.win ? '_winnings' : '_regular'), 0)
                    .setX(item.x)
                    .setY(item.multiplierSprite.y)
                    .setAlpha(0);

                this.customHelper.applyDynamicSpriteSize(item.amount, item.width - 50);

                let scaleTo = item.amount.scaleX;
                item.amount.setScale(0);
                item.amount.setAngle(item.angle)

                this.mainGameGroup.add(item.amount);

                if (!scenarioItem.win) {
                    item.greyItem.setTexture(`symbol_${scenarioItem.symbol}_grey`);

                    this.tweens.add({
                        targets: item.greyItem,
                        alpha: 1,
                        duration: 100,
                        ease: 'Power0'
                    });

                    if (scaleTo > 0.8) {
                        scaleTo = 0.8;
                    }
                }

                item.tween = this.tweens.add({
                    targets: [item.amount],
                    scale: scaleTo,
                    alpha: 1,
                    duration: 100,
                    ease: scenarioItem.win ? Phaser.Math.Easing.Back.Out : 'Power0',
                    onComplete: () => {
                        if (scenarioItem.win) {
                            this.request.addAmountWon(scenarioItem.amount);
                        }

                        if (symbolOpenedAs === 15) {
                            this.checkForContinueGame();
                        }
                    }
                });
            }
        });

        this.symbolsOpened++;
    }

    runWinAll(item)
    {
        this.disableYourSymbolsClicks();

        this.stopIdleTimer();
        this.mainGameGroup.bringToTop(this.frontContainerFader);
        item.mouseOverSprite.destroy();

        this.tweens.add({
            targets: this.frontContainerFader,
            alpha: 0.5,
            ease: 'Power0',
            duration: 500
        });

        const symbol = `stone_open_${this.request.scenario.win_all_bonus.symbol}`;

        this.winAllTempSymbol = this.add.sprite(item.x, item.y, symbol).setAngle(item.angle).setFrame(`Stone_${this.request.scenario.win_all_bonus.symbol}_Open_0011.png`);

        this.mainGameGroup.add(this.winAllTempSymbol);

        this.sound.play('sfx_win_jackpot');

        this.tweens.add({
            targets: this.winAllTempSymbol,
            scale: 1.4,
            ease: Phaser.Math.Easing.Quartic.Out,
            duration: 400,
            onComplete: () => {
                item.setAlpha(0);
                this.tweens.add({
                    targets: this.winAllTempSymbol,
                    x: this.jackpotIndicator.x,
                    y: this.jackpotIndicator.y,
                    angle: 0,
                    ease: Phaser.Math.Easing.Sine.Out,
                    duration: 300,
                    onComplete: () => {
                        this.tweens.add({
                            targets: this.winAllTempSymbol,
                            scale: 1.5,
                            ease: Phaser.Math.Easing.Sine.Out,
                            duration: 300,
                            onComplete: () => {
                                this.tweens.add({
                                    targets: this.winAllTempSymbol,
                                    scale: 1.3,
                                    ease: Phaser.Math.Easing.Sine.In,
                                    duration: 150,
                                    onComplete: () => {
                                        this.winAllTempSymbol.setAlpha(0);
                                        this.winAllTempSymbol.setX(this.jackpotIndicator.x).setY(this.jackpotIndicator.y);

                                        this.tweens.add({
                                            targets: this.frontContainerFader,
                                            alpha: 0,
                                            ease: 'Power0',
                                            duration: 100,
                                            onComplete: () => {
                                                this.cameras.main.shake(600, 0.005);
                                            }
                                        });

                                        this.jackpotIndicatorAfter.setAlpha(1).play(`win_${this.request.scenario.win_all_bonus.symbol}`);
                                        this.jackpotIndicatorWinFx.play('win_fx');
                                        this.markWinAllWinners();

                                        this.burstCoins(this.jackpotIndicatorWinFx.x + this.mainGameGroup.x, this.jackpotIndicatorWinFx.y + this.mainGameGroup.y);
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });
    }

    markWinAllWinners()
    {
        let groupedByRow = {0:{},1:{},2:{},3:{}};
        let rowOrdersToSearchPrev = {0:[1,2,3,0],1:[0,2,3,1],2:[3,1,0,2],3:[2,1,0,3]};

        let counter = 0;
        let currentGroup = 0;

        for (let key in this.mainGameItems['your_symbols']) {
            if (!this.mainGameItems['your_symbols'][key].opened) {
                groupedByRow[currentGroup][counter] = this.mainGameItems['your_symbols'][key];
            }

            counter++;

            if (counter === 4) {
                counter = 0;
                currentGroup++;
            }
        }

        counter = 0;
        let delay = 0;
        let lastActiveGroup = 0;

        Object.keys(groupedByRow).forEach(key => {
            if (Object.keys(groupedByRow[key]).length > 0) {
                if (!counter) {
                    Object.keys(groupedByRow[key]).forEach(key2 => {
                        this.markWinAllWinner(groupedByRow[key][key2], this.jackpotIndicator, delay);
                    })
                } else {
                    Object.keys(groupedByRow[key]).forEach(key2 => {
                        let fromItem = false;

                        for (let i = 0; i < rowOrdersToSearchPrev[key2].length; ++i) {
                            if (groupedByRow[lastActiveGroup][rowOrdersToSearchPrev[key2][i]]) {
                                fromItem = groupedByRow[lastActiveGroup][rowOrdersToSearchPrev[key2][i]];

                                this.markWinAllWinner(groupedByRow[key][key2], fromItem, delay);
                                break;
                            }
                        }
                    })
                }

                this.time.delayedCall(delay, () => {
                    this.sound.play('sfx_thunder_big');
                });

                counter++;
                delay += 300;

                lastActiveGroup = key;
            }
        });
    }

    markWinAllWinner(item, lightFrom, delay)
    {
        this.time.delayedCall(delay, () => {
            const scenarioItem = this.request.scenario.your_symbols[this.symbolsOpened];
            ;
            if (scenarioItem.symbol !== 'bonus_all_symbol') {
                return;
            }

            this.stopItemIdle(item);

            this.symbolsOpened++;

            item.play(`win_${this.request.scenario.win_all_bonus.symbol}`);

            item.lastOpenedAs = this.request.scenario.win_all_bonus.symbol;

            this.openedYourSymbolsLucky.push(item);

            const amount = General.format_currency(scenarioItem.amount).replace(Config.currency.symbol, '');

            item.amount = this.customHelper
                .createWinningFromSprites(amount, 1, '_winnings', 0)
                .setX(item.x)
                .setY(item.multiplierSprite.y);

            this.request.addAmountWon(scenarioItem.amount);

            this.mainGameGroup.add(item.amount);
            item.amount.setAngle(item.angle);
            this.customHelper.applyDynamicSpriteSize(item.amount, item.width - 50);
            this.mainGameGroup.bringToTop(item.fronEffect);
            item.fronEffect.play('win_fx');

            this.shootLightningFromTo(
                lightFrom.x,
                lightFrom.y,
                item.x,
                item.y
            );

            if (scenarioItem.amount_after) {
                item.amount_after = General.format_currency(scenarioItem.amount_after).replace(Config.currency.symbol, '');

                item.amount_add_to_won = scenarioItem.amount_after - scenarioItem.amount;
            }

            if (this.symbolsOpened === 16) {
                item.fronEffect.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                    this.checkForContinueGame();
                });
            }
        });
    }

    disableYourSymbolsClicks()
    {
        for (let i = 0; i < 16; i++) {
            let item = this.mainGameItems['your_symbols'][i];

            this.customHelper.removeClickable(item);

            if (item.mouseOverSprite) {
                item.mouseOverSprite.setAlpha(0);
            }
        }
    }

    enableIdleTimer()
    {
        this.idleTimer = this.time.addEvent({
            delay: 10000,
            callback: this.shakeUnopenedSymbols,
            callbackScope: this,
            loop: true
        });
    }

    resetIdleTimer()
    {
        this.stopIdleTimer();
        this.enableIdleTimer();
    }

    stopIdleTimer()
    {
        if (this.idleTimer) {
            this.idleTimer.remove();
        }
    }

    stopItemIdle(item)
    {
        if (item.mouseOverSprite && item.mouseOverSprite.tween && item.mouseOverSprite.tween.isPlaying()) {
            item.mouseOverSprite.tween.stop();
        }

        item.mouseOverSprite.setAlpha(0);
    }

    shakeUnopenedSymbols()
    {
        this.sound.play('sfx_bonus_cards_glow');

        for (let i = 0; i < 16; i++) {
            let item = this.mainGameItems['your_symbols'][i];

            if (item.mouseOverSprite && !item.opened && item.mouseOverSprite.alpha === 0) {
                item.mouseOverSprite.tween = this.tweens.add({
                    targets: [item.mouseOverSprite],
                    alpha: 1,
                    duration: 1000,
                    ease: 'Power0',
                    yoyo: true,
                    repeat: 1
                });
            }
        }
    }

    shootLightningFromTo(fromX, fromY, toX, toY)
    {
        let currentLightning = this.add.sprite(fromX, fromY, 'magic_beam_short').setOrigin(0.5, 0.08).setVisible(false).setFrame('Magic_Beam_Short_0000.png');

        let distance = Phaser.Math.Distance.Between(fromX, fromY, toX, toY) + 60;

        if (distance > this.lightningShort.height) {
            currentLightning.destroy();
            currentLightning = this.add.sprite(fromX, fromY, 'magic_beam_medium').setOrigin(0.5, 0.08).setVisible(false).setFrame('Magic_Beam_Medium_0000.png');

            if (distance > this.lightningMedium.height) {
                currentLightning.destroy();
                currentLightning = this.add.sprite(fromX, fromY, 'magic_beam_long').setOrigin(0.5, 0.08).setVisible(false).setFrame('Magic_Beam_Long_0000.png');
            }
        }

        this.mainGameGroup.add(currentLightning);

        currentLightning.setScale(distance / (currentLightning.height - 115));

        let point = Phaser.Math.Angle.BetweenY(currentLightning.x, currentLightning.y, toX, toY) * -1;

        currentLightning.rotation = point;
        currentLightning.play(currentLightning.texture.key);

        currentLightning.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
            currentLightning.destroy();
        });
    }

    ticketFinished()
    {
        this.tweens.add({
            targets: [this.mainSound, this.mainAmbSound],
            volume: 1,
            duration: 500,
        });

        store.commit('hideOpenAllButton');
        this.request.ticketFinished();
    }

    afterComplete()
    {
    }

    openAll()
    {
        this.sound.play('sfx_click_spin');

        if (this.bonusRunning || this.winAllRunning) {
            return;
        }

        let symbolOpened = false;

        for (let i = 0; i < this.yourSymbolsByRows.length; i++) {
            for (let j = 0; j < this.yourSymbolsByRows[i].length; j++) {
                let item = this.yourSymbolsByRows[i][j];

                if (!item.opened) {
                    this.sound.play('sfx_cards_row_reveal');
                    this.openYourSymbol(item.absoluteIndex, item, true);

                    const scenarioItem = this.request.scenario.your_symbols[this.symbolsOpened-1];

                    if (['bonus_all_symbol', 'bonus_symbol'].includes(scenarioItem)) {
                        return;
                    }

                    symbolOpened = true;

                    if (Config.assets.settings.disable_open_all && symbolOpened && j === this.yourSymbolsByRows[i].length-1) {
                        return;
                    }
                }
            }
        }
    }

    createFader()
    {
        this.fullFaderMain = this.add.graphics().fillStyle(0x000000, 1).fillRect(0, 0, 1920, 1920);
        this.fullFaderMain.setAlpha(0.4);
    }

    fadeInMainFader(alpha, time)
    {
        this.children.bringToTop(this.fullFaderMain);
        this.tweens.add({
            targets: this.fullFaderMain,
            alpha: alpha ? alpha : 0.4,
            ease: 'Power0',
            duration: time ? time : 500
        });
    }

    createLightnings()
    {
        this.lightningShort = this.add.sprite(0, 0, 'magic_beam_short').setOrigin(0.5, 0.08).setVisible(false);
        this.lightningMedium = this.add.sprite(0, 0, 'magic_beam_medium').setOrigin(0.5, 0.08).setVisible(false);
        this.lightningLong = this.add.sprite(0, 0, 'magic_beam_long').setOrigin(0.5, 0.08).setVisible(false);

        let animationConfig = {
            key: 'magic_beam_long',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('magic_beam_long',
                {
                    prefix: 'Magic_Beam_Long_',
                    start: 0,
                    end: 27,
                    suffix: '.png',
                    zeroPad: 4
                }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'magic_beam_medium',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('magic_beam_medium',
                {
                    prefix: 'Magic_Beam_Medium_',
                    start: 0,
                    end: 27,
                    suffix: '.png',
                    zeroPad: 4
                }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'magic_beam_short',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('magic_beam_short',
                {
                    prefix: 'Magic_Beam_Short_',
                    start: 0,
                    end: 27,
                    suffix: '.png',
                    zeroPad: 4
                }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);
    }

    createBg()
    {
        this.bg = this.add.sprite(0, 0, 'bg').setOrigin(0.5, 1);
        this.positionerContainer.add(this.bg);
    }

    createOtherAnimations()
    {
        let animationConfig = {
            key: 'bat',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('bat', {
                start: 0,
                end: 5,
            }),
            frameRate: 25,
            repeat: -1
        };

        batAnim = this.anims.create(animationConfig);

        animationConfig = {
            key: 'smoke_puff',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('smoke_puff', {
                prefix: 'Smoke_Puff_',
                start: 0,
                end: 27,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);


        animationConfig = {
            key: 'cloud_smoke',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('cloud_smoke', {
                prefix: 'Cloud_Smoke_',
                start: 0,
                end: 34,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true,
            repeat: -1
        };

        this.anims.create(animationConfig);
    }

    createCoinsBurster()
    {
        let animationConfig = {
            key: 'coins',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('coins', {
                start: 0,
                end: 7,
            }),
            frameRate: 25,
            repeat: -1
        };

        coinsAnim = this.anims.create(animationConfig);

        const particles = this.add.particles('coins');

        this.coinsEmitter = particles.createEmitter({
            frame: 0,
            x: 0,
            y: 0,
            lifespan: 2000,
            speedY: { min: 100, max: -500 },
            speedX: { min: -300, max: 300 },
            particleClass: AnimatedParticle,
            gravityY: 1000,
            quantity: 1,
            on: false
        });
    }

    burstCoins(x, y)
    {
        this.coinsEmitter.setPosition(x, y);
        this.coinsEmitter.explode(30);
    }

    customPlayButtonEvent()
    {
        for (let i = this.bonusSymbolsOpened; i < this.request.scenario.bonus.luckies.length; i++) {
            let scenarioItem = this.request.scenario.bonus.luckies[i];

            for (let [index, item] of Object.entries(this.bonusItems)) {
                if (!item.opened) {
                    this.openBonusSymbol(item);
                    if (!scenarioItem) {
                        store.commit('disableCustomPlayButton');
                        return;
                    }
                    return;
                }
            }
        }
    }

    createMultiplier()
    {
        this.smokeLoop = this.add.sprite(0, 0, 'smoke_loop');
        this.multiplier = this.add.sprite(0, 0, 'multiplier_x1').setVisible(false);
        this.couldronActivate = this.add.sprite(0, 0, 'couldron_activate_fx').setVisible(false);
        this.couldronReveal = this.add.sprite(0, 0, 'couldron_reveal_fx').setVisible(false);
        this.couldronBase = this.add.sprite(0, 0, 'couldron_base');

        let animationConfig = {
            key: 'smoke_loop',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('smoke_loop', {
                prefix: 'Smoke_Loop_',
                start: 0,
                end: 49,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true,
            repeat: -1
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'couldron_activate_fx',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('couldron_activate_fx', {
                prefix: 'Couldron_Activate_FX_',
                start: 0,
                end: 26,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true,
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'couldron_reveal_fx',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('couldron_reveal_fx', {
                prefix: 'Couldron_Reveal_FX_',
                start: 0,
                end: 28,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true,
        };

        this.anims.create(animationConfig);

        [1, 2, 3, 5].forEach((multiplier) => {
            animationConfig = {
                key: `multiplier_x${multiplier}`,
                skipMissedFrames: true,
                frames: this.anims.generateFrameNames(`multiplier_x${multiplier}`, {
                    prefix: `x${multiplier}_`,
                    start: 0,
                    end: 19,
                    zeroPad: 4,
                    suffix: '.png'
                }),
                frameRate: 25,
                showOnStart: true,
                hideOnComplete: true,
                repeat: -1
            };

            this.anims.create(animationConfig);
        });

        this.smokeLoop.play('smoke_loop');

        this.bonusBg = this.add.sprite(0, 0, 'bonus_bg').setAlpha(0);
    }

    showBonus()
    {
        this.tweens.add({
            targets: [this.mainSound, this.mainAmbSound],
            volume: 0,
            duration: 500,
            onComplete: () => {
                this.mainSound.stop();
                this.mainAmbSound.stop()
            }
        });

        this.bonusSound.play();
        this.bonusSoundAmb.play();

        this.tweens.add({
            targets:  [this.bonusSound, this.bonusSoundAmb],
            volume:  1,
            duration: 500
        });

        this.bonusTweens = [];

        this.bonusContainer.setAlpha(1);

        this.cameras.main.shake(1000, 0.001);

        this.tweens.add({
            targets: this.bonusBg,
            alpha: 1,
            ease: 'Power0',
            duration: 1000,
        });

        this.sound.play('sfx_bonus_tombstone_down');

        this.bonusTweens.push(this.tweens.add({
            targets: [this.mainGameGroup],
            y: this.cameras.main.height + this.mainFrame.height / 2 + 150,
            ease: 'Power0',
            duration: 1000,
            onComplete: () => {
                this.bonusTweens = [];

                for (let i = 0; i < 10; i++) {
                    let item = this.bonusItems[i];

                    item.setInteractive({ cursor: 'pointer', pixelPerfect: true})
                        .on('pointerup', () => {
                            this.openBonusSymbol(item);
                        })
                        .on('pointerover', () => {
                            item.hoverTween = this.tweens.add({
                                targets: item,
                                scale: 0.9,
                                ease: 'Power0',
                                duration: 100,
                            });

                            this.sound.play('sfx_bonus_pumpkin_hover_0' + Phaser.Math.RND.integerInRange(1, 3));
                        })
                        .on('pointerout', () => {
                            if (item.hoverTween && item.hoverTween.isPlaying) {
                                item.hoverTween.stop();
                            }

                            item.hoverTween = this.tweens.add({
                                targets: item,
                                scale: 1,
                                ease: 'Power0',
                                duration: 100,
                            });
                        });
                }

                store.commit('hideOpenAllButton');
                store.commit('showCustomPlayButton', 'icon_open-all.svg');
            }
        }));
    }

    openBonusSymbol(item)
    {
        if (item.opened || this.allNeededBonusItemsOpened) {
            return;
        }

        this.customHelper.removeClickable(item);

        if (item.hoverTween && item.hoverTween.isPlaying) {
            item.hoverTween.stop();
        }

        item.setScale(1);

        item.opened = true;

        const scenarioItem = this.request.scenario.bonus.luckies[this.bonusSymbolsOpened];

        this.bonusSymbolsOpened++;

        let symbolOpenedAs = this.bonusSymbolsOpened;

        if (scenarioItem) {
            const amount = General.format_currency(scenarioItem).replace(Config.currency.symbol, '');

            item.amount = this.customHelper
                .createWinningFromSprites(amount, 1, '_bonus_win', 0)
                .setX(item.x)
                .setY(item.y)
                .setAlpha(0);

            this.customHelper.applyDynamicSpriteSize(item.amount, item.width - 50);

            let scaleTo = item.amount.scaleX;

            this.bonusContainer.add(item.amount);
            this.bonusContainer.bringToTop(item);

            item.play('pumpkin_smash');

            item.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                item.setAlpha(0);
            });

            item.amount.setScale(0).setAlpha(1);

            this.sound.play('sfx_bonus_pumpkin_explosion_win_0' + Phaser.Math.RND.integerInRange(1, 3));

            this.tweens.add({
                targets: [item.amount],
                scale: scaleTo,
                duration: 700,
                ease: Phaser.Math.Easing.Cubic.Out,
                onComplete: () => {
                    this.request.addAmountWon(scenarioItem);

                    if (symbolOpenedAs === 10) {
                        store.commit('disableCustomPlayButton');

                        this.time.delayedCall(2500, () => {
                            this.backToMainGame();
                        });
                    }
                }
            });

        } else {
            this.allNeededBonusItemsOpened = true;
            this.disableBonusClicks();
            item.amount = this.add.sprite(item.x, item.y, 'poison_activate').setScale(0);

            this.bonusContainer.add(item.amount);
            this.bonusContainer.bringToTop(item);

            item.play('pumpkin_smash');

            this.sound.play('sfx_bonus_pumpkin_explosion_poison');

            this.tweens.add({
                targets: [item.amount],
                scale: 1,
                duration: 700,
                ease: Phaser.Math.Easing.Cubic.Out,
                onComplete: () => {
                    item.amount.play('poison_activate');

                    item.amount.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                        this.sound.play('sfx_bonus_pumpkin_rot');
                        this.showNotWonBonusItems();
                    });
                }
            });
        }
    }

    showNotWonBonusItems()
    {
        let unluckiesOpened = 0;

        if (!this.request.scenario.bonus.unluckies) {
            this.time.delayedCall(2500, () => {
                this.backToMainGame();
            });
        }

        let delay = 0;

        for (let i = 0; i < 10; i++) {
            let item = this.bonusItems[i];

            if (!item.opened) {
                const scenarioItem = this.request.scenario.bonus.unluckies[unluckiesOpened];

                this.showUnopenedItem(item, scenarioItem, delay, (unluckiesOpened === this.request.scenario.bonus.unluckies.length-1 ? () => {
                    this.time.delayedCall(1000, () => {
                        this.backToMainGame();
                    });
                } : false));

                //delay += 300;

                unluckiesOpened++;
            }
        }
    }

    backToMainGame()
    {
        this.tweens.add({
            targets:  [this.bonusSound, this.bonusSoundAmb],
            volume:  0,
            duration: 500,
            onComplete: () => {
                this.bonusSound.stop();
                this.bonusSoundAmb.stop()
            }
        });

        this.mainSound.play();
        this.mainAmbSound.play();

        this.tweens.add({
            targets: [this.mainSound, this.mainAmbSound],
            volume: 0.5,
            duration: 500,
        });

        this.bonusRunning = false;

        this.request.reportEvent('bonus_end');

        this.tweens.add({
            targets: this.bonusBg,
            alpha: 0,
            ease: 'Power0',
            duration: 1000,
        });

        this.sound.play('sfx_bonus_tombstone_up');

        this.bonusTweens.push(this.tweens.add({
            targets: this.mainGameGroup,
            y: this.mainGameGroup.currentOriginY,
            ease: Phaser.Math.Easing.Quartic.Out,
            duration: 1000,
            onComplete: () => {
                this.bonusTweens = [];
                this.bonusContainer.setAlpha(0);
                store.commit('hideCustomPlayButton');

                this.checkForContinueGame();
            }
        }));
    }

    checkForContinueGame()
    {
        if (this.symbolsOpened === 16) {
            store.commit('disableOpenAllButton');

            if (this.request.scenario.multiplier > 1 && !this.multiplierFinished && this.openedYourSymbolsLucky.length) {
                this.showMultiplier();
            } else {
                this.time.delayedCall(1000, () => {
                    this.finishGame();
                });
            }

            this.stopIdleTimer();
        } else {
            this.resetIdleTimer();
            store.commit('showOpenAllButton');
        }
    }

    finishGame()
    {
        if (this.request.scenario.total_prize > 0) {
            const ratio = this.request.scenario.total_prize / this.request.ticketAmount;

            if (ratio >= Config.assets.ratios.big_win) {
                this.showBigWin();
            } else {
                this.showRegularWin();
            }
        } else {
            this.fadeInMainFader();
            this.ticketFinished();
        }
    }

    showMultiplier()
    {
        this.time.delayedCall(1000, () => {
            this.couldronActivate.play('couldron_activate_fx');
            let symbolToShoot = false;
            let delay = 200;

            for (let j = 0; j < this.yourSymbolsByRows.length; j++) {
                for (let i = 3; i >= 0; i--) {
                    if (this.yourSymbolsByRows[j][i].amount_after) {
                        if (symbolToShoot) {
                            this.playItemMultiplied(this.yourSymbolsByRows[j][i], delay);
                            delay += 50;
                        } else {
                            symbolToShoot = this.yourSymbolsByRows[j][i];
                            delay = this.flyParticleTo(
                                this.couldronActivate.x,
                                this.couldronActivate.y,
                                symbolToShoot.amount.x + this.mainGameGroup.x,
                                symbolToShoot.amount.y + this.mainGameGroup.y,
                                () => {
                                    this.playItemMultiplied(symbolToShoot, 0);
                                }
                            );

                            this.sound.play('sfx_win_multiplier');

                            delay += 50;
                        }
                    }
                }
            }
            this.time.delayedCall(delay + 1000, () => {
                this.finishGame();
            });
        });
    }

    playItemMultiplied(item, delay)
    {
        this.time.delayedCall(delay, () => {
            item.amount.destroy();
            this.mainGameGroup.bringToTop(item.multiplierSprite);
            item.amount = this.customHelper
                .createWinningFromSprites(item.amount_after, 1, '_winnings', 0)
                .setX(item.x)
                .setY(item.multiplierSprite.y);

            this.customHelper.applyDynamicSpriteSize(item.amount, item.width - 50);

            item.amount.setAngle(item.angle);

            this.mainGameGroup.add(item.amount);

            this.tweens.add({
                targets: item.amount,
                alpha: 1,
                scale: item.amount.scaleX + 0.2,
                duration: 300,
                yoyo: true,
                ease: 'Power0'
            });

            item.multiplierSprite.play('couldron_activate_fx');
            this.request.addAmountWon(item.amount_add_to_won);
        });
    }

    flyParticleTo(startX, startY, destinationX, destinationY, callback)
    {
        let startPoint = new Phaser.Math.Vector2(startX, startY);
        let distance = Phaser.Math.Distance.Between(startX, startY, destinationX, destinationY);
        let controlX = startX - distance / 2;

        if (destinationX > startX) {
            controlX = startX + distance / 2;
        }

        let controlY = startY - 200;

        if (destinationY > startY) {
            controlY = startY + 200;
        }

        let controlPoint1 = new Phaser.Math.Vector2(controlX, controlY);

        let endPoint = new Phaser.Math.Vector2(destinationX, destinationY);

        let curve = new Phaser.Curves.QuadraticBezier(startPoint, controlPoint1, endPoint);
        let newDistance = curve.getLength();

        let scaler = 0.5;
        let itemsCount = 20;

        for (var i = 0; i < itemsCount; i++) {
            this.addFollower(curve, newDistance, scaler, i, callback);

            scaler -= (0.5 / (itemsCount * 1.5));
        }

        return distance / 1.8;
    }

    addFollower(path, distance, scaler, i, callback, callbackParams)
    {
        let  follower = this.add.follower(path, 100, 100, 'flares', 'green');
        follower.setDepth(10);
        follower.setBlendMode(Phaser.BlendModes.ADD);
        follower.setScale(scaler);

        follower.startFollow({
            duration:distance / 1.8,
            positionOnPath: true,
            ease: 'Linear',
            delay: i * 5,
            onComplete: () => {
                follower.destroy();

                if (i === 0) {
                    if (callback) {
                        callback();
                    }
                }
            }
        });
    }

    showUnopenedItem(item, scenarioItem, delay, callback)
    {
        this.time.delayedCall(delay, () => {
            const amount = General.format_currency(scenarioItem).replace(Config.currency.symbol, '');

            item.amount = this.customHelper
                .createWinningFromSprites(amount, 1, '_bonus_loose', 0)
                .setX(item.x)
                .setY(item.y)
                .setAlpha(0);

            this.bonusContainer.add(item.amount);

            this.customHelper.applyDynamicSpriteSize(item.amount, item.width - 50);

            const scaleTo = item.amount.scaleX;

            item.play('pumpkin_rot');

            item.amount.setScale(0).setAlpha(1);

            this.tweens.add({
                targets: [item.amount],
                scale: scaleTo,
                alpha: 1,
                duration: 700,
                ease: Phaser.Math.Easing.Cubic.Out,
                onComplete: () => {
                    if (callback) {
                        callback();
                    }
                }
            });
        });
    }

    disableBonusClicks()
    {
        for (let i = 0; i < 10; i++) {
            let item = this.bonusItems[i];

            this.customHelper.removeClickable(item);
        }
    }

    createBonus()
    {
        this.bonusContainer = this.add.container();
        this.bonusContainer.setAlpha(0);

        let animationConfig = {
            key: 'poison_activate',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('poison_activate', {
                prefix: 'Poison_Activate_',
                start: 0,
                end: 40,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'pumpkin_smash',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('pumpkin_smash', {
                prefix: 'Pumpkin_Smash_',
                start: 0,
                end: 27,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'pumpkin_rot',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('pumpkin_rot', {
                prefix: 'Pumpkin_Rot_',
                start: 0,
                end: 33,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25
        };

        this.anims.create(animationConfig);


        let i = 0;
        let startY = -270;
        this.bonusItems = {};

        for (let [index, count] of [3, 3, 3, 1].entries()) {
            let startX = count === 3 ? -250 : 0;

            if (index === 1) {
                startX = -310;
            }

            for (let k = 0; k < count; k++) {
                let offsetY = 0;

                if (count === 3 && k === 1) {
                    offsetY =  -100;
                }

                if (count === 1) {
                    offsetY = -100;
                }

                let item = this.add.sprite(startX, startY + offsetY, 'pumpkin_smash').setFrame('Pumpkin_Smash_0000.png');
                this.bonusContainer.add(item);

                this.bonusItems[i] = item;

                if (index === 1) {
                    startX += 310;
                } else {
                    startX += 250;
                }

                i++;
            }

            startY += 220;
        }


    }

    createGameItems()
    {
        this.groundPortrait = this.add.sprite(0, 0, 'ground_portrait').setOrigin(0.5, 1);
        this.frontDirt = this.add.sprite(0, 0, 'front_dirt').setOrigin(0.5, 1);
        this.logo = this.add.sprite(0, 0, 'logo');
        this.witch = this.add.sprite(0, 0, 'witch').setOrigin(0, 1);

        this.mainFrame = this.add.sprite(0, 0, 'main_frame').setOrigin(0.5, 0);
        this.mainGameGroup.add(this.mainFrame);

        this.mainGameItems = {'lucky_symbols':{}, 'your_symbols':{}};
        this.yourSymbolsByRows = [];

        this.frontContainerFader = this.add.graphics().fillStyle(0x000000, 1).fillRect(0, 0, 2500, 2500).setAlpha(0);
        this.mainGameGroup.add(this.frontContainerFader);

        this.jackpotIndicator = this.add.sprite(0, -375, '');
        this.mainGameGroup.add(this.jackpotIndicator);

        this.jackpotIndicatorAfter = this.add.sprite(0, this.jackpotIndicator.y, `win_1`).setAlpha(0).setScale(1.3);
        this.mainGameGroup.add(this.jackpotIndicatorAfter);
        this.jackpotSlotOpen = this.add.sprite(0, this.jackpotIndicator.y, 'jackpot_slot_open');
        this.mainGameGroup.add(this.jackpotSlotOpen);
        this.jackpotIndicatorWinFx = this.add.sprite(0, this.jackpotIndicator.y, `win_fx`).setVisible(0).setScale(1.3);
        this.mainGameGroup.add(this.jackpotIndicatorWinFx);

        this.luckySymbolsLabel = this.add.sprite(0, 0, 'lucky_symbols').setOrigin(0.5, 0);
        this.mainGameGroup.add(this.luckySymbolsLabel);
        this.yourSymbolsLabel = this.add.sprite(0, 0, 'your_symbols').setOrigin(0.5, 0);
        this.mainGameGroup.add(this.yourSymbolsLabel);

        this.loadSymbolsAnimations();

        let startX = -(this.mainFrame.width / 2) + 190;
        let y = -353;

        for (let i = 0; i < 4; i++) {
            let angle = (i === 1 || i === 2 ? 3.27 : 5.09);

            let item = this.add.sprite(startX, (i === 1 || i === 2 ? y - 10 : y), 'gold_cover_flip').setFrame('Gold_Cover_Flip_0000.png').setAngle(i < 2 ? angle*-1 : angle);
            this.mainGameGroup.add(item);
            this.mainGameItems['lucky_symbols'][i] = item;

            startX += i === 1 ? 375 : this.mainGameItems['lucky_symbols'][i].width - 48;
        }

        startX = -(this.mainFrame.width / 2) + 255;
        y = -135;
        let counter = 0;
        let xOffset = 34;
        let currentX = startX;
        let offsetsLeft = {
            0: 13,
            1: 27,
            2: 39,
            3: 52,
        }

        let offsetLeft = {
            0: {
                'normal': 190,
                'middle': 173,
                'last': 186
            },
            1: {
                'normal': 179,
                'middle': 167,
                'last': 177
            },
            2: {
                'normal': 168,
                'middle': 160,
                'last': 168
            },
            3: {
                'normal': 160,
                'middle': 154,
                'last': 158
            }
        };

        for (let i = 0; i < 4; i++) {
            for (let j = 0; j < 4; j++) {
                let angle = (j === 1 || j === 2 ? 1.13 : 4.64);
                angle = j < 2 ? angle*-1 : angle;

                let item = this.add.sprite(currentX, (j === 1 || j === 2 ? y - 10 : y), 'stone_cover_flip').setFrame('Stone_Cover_Flip_0000.png').setAngle(angle);
                this.mainGameGroup.add(item);

                item.greyItem = this.add.sprite(item.x, item.y, '').setAlpha(0).setAngle(angle);
                this.mainGameGroup.add(item.greyItem);

                item.fronEffect = this.add.sprite(item.x, item.y, 'win_fx').setVisible(0);
                this.mainGameGroup.add(item.fronEffect);

                item.mouseOverSprite = this.add.sprite(item.x, item.y + 10, 'symbol_hover').setAlpha(0).setAngle(angle);
                this.mainGameGroup.add(item.mouseOverSprite);

                item.multiplierSprite = this.add.sprite(item.x, item.y + item.displayHeight / 2 - 40, 'couldron_activate_fx').setVisible(false);
                this.mainGameGroup.add(item.multiplierSprite);

                this.mainGameItems['your_symbols'][counter] = item;
                item.absoluteIndex = counter;
                counter++;

                if (!this.yourSymbolsByRows[i]) {
                    this.yourSymbolsByRows[i] = [];
                }

                this.yourSymbolsByRows[i].push(item);

                if (j == 1) {
                    currentX += offsetLeft[i]['middle'];
                } else if (j == 2) {
                    currentX += offsetLeft[i]['last'];
                } else {
                    currentX += offsetLeft[i]['normal'];
                }
            }

            y += this.mainGameItems['your_symbols'][0].height - 43;
            currentX = startX + offsetsLeft[i];
        }
    }

    loadSymbolsAnimations()
    {
        let animations = {
            0: {
                'key': 'gold_open_--number--',
                'prefix': 'Gold_--number--_Open_',
                'start': 0,
                'end': 11
            },
            1: {
                'key': 'gold_close_--number--',
                'prefix': 'Gold_--number--_Close_',
                'start': 0,
                'end': 11
            },
            2: {
                'key': 'gold_close_to_stone_--number--',
                'prefix': 'Gold_--number--_Close_to_Stone_',
                'start': 0,
                'end': 11
            },
            3: {
                'key': 'stone_open_--number--',
                'prefix': 'Stone_--number--_Open_',
                'start': 0,
                'end': 11
            },
            4: {
                'key': 'stone_close_--number--',
                'prefix': 'Stone_--number--_Close_',
                'start': 0,
                'end': 11
            },
            5: {
                'key': 'jackpot_indicator_--number--',
                'prefix': 'Jackpot_--number--_Indicator_',
                'start': 0,
                'end': 24,
                'repeat':1
            },
            6: {
                'key': 'win_--number--',
                'prefix': '--number--_Win_',
                'start': 0,
                'end': 19
            },
        };

        let animationConfig = {
            key: 'jackpot_slot_open',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('jackpot_slot_open', {
                prefix: 'Jackpot_Slot_Open_',
                start: 0,
                end: 28,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25
        };

        this.anims.create(animationConfig);

        for (let item of Object.values(animations)) {
            for (let i = 1; i <= 10; i++) {
                let key = item.key.replace('--number--', i);
                let prefix = item.prefix.replace('--number--', i);

                animationConfig = {
                    key: key,
                    skipMissedFrames: true,
                    frames: this.anims.generateFrameNames(key, {
                        prefix: prefix,
                        start: item.start,
                        end: item.end,
                        zeroPad: 4,
                        suffix: '.png'
                    }),
                    frameRate: 25,
                    repeat: item.repeat ? -1 : 0
                };
                this.anims.create(animationConfig);
            }
        }

        animationConfig = {
            key: 'stone_cover_flip',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('stone_cover_flip', {
                prefix: 'Stone_Cover_Flip_',
                start: 0,
                end: 11,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'gold_cover_flip',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('gold_cover_flip', {
                prefix: 'Gold_Cover_Flip_',
                start: 0,
                end: 11,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'win_fx',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('win_fx', {
                prefix: 'Win_FX_',
                start: 0,
                end: 34,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'bonus_win',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('bonus_win', {
                prefix: 'BONUS_Win_',
                start: 0,
                end: 19,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'bonus_close',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('bonus_close', {
                prefix: 'BONUS_Close_',
                start: 0,
                end: 11,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'bonus_open',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('bonus_open', {
                prefix: 'BONUS_Open_',
                start: 0,
                end: 11,
                zeroPad: 4,
                suffix: '.png'
            }),
            frameRate: 25
        };

        this.anims.create(animationConfig);
    }

    showRegularWin()
    {
        this.regularWinDestroyed = false;
        this.regularWinContainer = this.add.container();
        this.regularWinContainer.setAlpha(0);
        this.fadeInMainFader(0.4);
        this.children.bringToTop(this.regularWinContainer);

        this.regularWinGlow = this.add.sprite(0, 0, 'win_glow').setScale(0);
        this.regularWinContainer.add(this.regularWinGlow);
        this.regularSmokePuff = this.add.sprite(0, 0, 'smoke_puff').setVisible(false);
        this.regularWinContainer.add(this.regularSmokePuff);

        this.regularWinAmountContainer = this.customHelper.createWinningFromSprites(General.format_currency(this.request.scenario.total_prize).replace(Config.currency.symbol, ''), 1, '_win', 0);
        this.regularWinContainer.add(this.regularWinAmountContainer);
        this.customHelper.applyDynamicSpriteSize(this.regularWinAmountContainer, this.regularSmokePuff.width - 250);

        let scaleTo = this.regularWinAmountContainer.scaleX;

        this.regularWinAmountContainer.setScale(0);
        this.regularWinPositioner();

        this.regularWinContainer.setAlpha(1);

        this.time.delayedCall(200, () => {
            this.regularSmokePuff.play('smoke_puff');
        });

        this.regularWinTween2 = this.tweens.add({
            targets: [this.regularWinGlow],
            scale: 1,
            ease: 'Power0',
            duration: 300
        });

        this.sound.play('sfx_win_small');

        this.regularWinTween = this.tweens.add({
            targets: [this.regularWinAmountContainer],
            scale: scaleTo,
            ease: 'Power0',
            duration: 300,
            delay: 300,
            onComplete: () => {
                this.regularWinContainer.setInteractive({ cursor: 'pointer'})
                    .once('pointerup', () => {
                        this.destroyRegularWin();
                    });

                this.regularWinTimer = this.time.delayedCall(2000, () => {
                    this.destroyRegularWin();
                });
            }
        });
    }

    regularWinPositioner()
    {
        if (!this.regularWinContainer) {
            return;
        }

        this.regularWinContainer.x = this.cameras.main.centerX;
        this.regularWinContainer.y = this.cameras.main.centerY;
        this.regularWinContainer.setSize(this.cameras.main.width, this.cameras.main.height);
    }

    destroyRegularWin()
    {
        if (this.regularWinDestroyed) {
            return;
        }

        this.regularWinDestroyed = true;

        this.customHelper.removeClickable(this.regularWinContainer);

        /*this.tweens.add({
            targets: this.fullFaderMain,
            alpha: 0,
            ease: 'Power0',
            duration: 300,
        });*/

        if (this.regularWinTimer) {
            this.regularWinTimer.remove();
        }

        this.tweens.add({
            targets: [this.regularWinContainer],
            scale: 0,
            ease: 'Power0',
            duration: 300,
            onComplete: () => {
                if (this.regularWinTween && this.regularWinTween.isPlaying()) {
                    this.regularWinTween.stop();
                    this.regularWinTween.remove();
                }

                if (this.regularWinTween2 && this.regularWinTween2.isPlaying()) {
                    this.regularWinTween2.stop();
                    this.regularWinTween2.remove();
                }

                if (this.regularWinContainer) {
                    this.regularWinContainer.destroy();
                }

                if (this.regularWinAmountContainer) {
                    this.regularWinAmountContainer.destroy();
                }

                this.ticketFinished();
            }
        });
    }

    showBigWin()
    {
        this.bigWinDestroyed = false;
        this.bigWinContainer = this.add.container();;
        this.bigWinContainer.setAlpha(0);
        this.fadeInMainFader(0.4);

        this.children.bringToTop(this.bigWinContainer);

        this.bigWinGlow = this.add.sprite(0, 0, 'glow_big').setScale(0);
        this.bigWinContainer.add(this.bigWinGlow);

        this.bigWinParticle = this.add.particles('bat');

        this.bigWinEmitter = this.bigWinParticle.createEmitter({
            frame: 0,
            x: 0,
            y: 0,
            speed: 500,
            lifespan: 6000,
            quantity: 1,
            frequency: 20,
            scale: { min: 0.4, max: 1 },
            particleClass: AnimatedParticleBat,
            on: false,
            rotate: {
                onEmit: (particle) => {
                    let point = Phaser.Math.Angle.BetweenY(0, 0, particle.velocityX, particle.velocityY) * -1;

                    return Phaser.Math.RadToDeg(point) + 180;
                },
            }
        });

        this.bigWinContainer.add(this.bigWinParticle);

        this.bigCloudSmoke = this.add.sprite(0, 0, 'cloud_smoke').setVisible(false).setScale(0);
        this.bigWinContainer.add(this.bigCloudSmoke);

        if (Config.assets.settings.show_big_win_text) {
            this.bigWinText = this.add.sprite(0, 0, 'big_win_text').setScale(0);
            this.bigWinContainer.add(this.bigWinText);
        }

        let checkerSizes = this.customHelper.createWinningFromSprites(General.format_currency(this.request.scenario.total_prize).replace(Config.currency.symbol, ''), 1, '_win', 0).setAlpha(0);
        this.customHelper.applyDynamicSpriteSize(checkerSizes,  this.bigCloudSmoke.width - 150);

        this.bigWinAmountSubContainer = this.add.container();
        this.bigWinContainer.add(this.bigWinAmountSubContainer);

        this.bigWinAmountContainer = this.customHelper.createWinningFromSprites(General.format_currency(0).replace(Config.currency.symbol, ''), 1, '_win', 0).setScale(checkerSizes.scaleX).setAlpha(0);
        this.bigWinAmountSubContainer.add(this.bigWinAmountContainer);
        this.customHelper.applyDynamicSpriteSize(this.bigWinAmountContainer, this.bigCloudSmoke.width - 150);
        checkerSizes.destroy();
        this.bigWinAmountSubContainer.setScale(0);

        this.bigWinPositioner();

        this.bigWinContainer.setAlpha(1);

        this.batsSound.play();

        this.bigCloudSmoke.play('cloud_smoke');

        this.bigWinTween2 = this.tweens.add({
            targets: [this.bigWinGlow, this.bigCloudSmoke],
            scale: 1,
            ease: 'Power0',
            duration: 300
        });

        this.time.delayedCall(100, () => {
            this.bigWinEmitter.start();
        });

        this.stgBigWin.play();

        if (this.bigWinText) {
            this.bigWinTween = this.tweens.add({
                targets: [this.bigWinText],
                scale: 1,
                ease: Phaser.Math.Easing.Back.Out,
                duration: 300,
                delay: 200,
                onComplete: () => {
                    this.bigWinTween = this.tweens.add({
                        targets: [this.bigWinAmountSubContainer],
                        scale: 1,
                        ease: Phaser.Math.Easing.Back.Out,
                        duration: 300,
                        onComplete: () => {
                            this.bigWinContainer.setInteractive({cursor: 'pointer'})
                                .once('pointerup', () => {
                                    this.destroyBigWin(true);
                                });
                        }
                    });

                    this.bigWinAmountContainer.setAlpha(1);
                    this.incrementTo(this.request.scenario.total_prize);
                }
            });
        } else {
            this.bigWinTween = this.tweens.add({
                targets: [this.bigWinAmountSubContainer],
                scale: 1,
                ease: Phaser.Math.Easing.Back.Out,
                duration: 300,
                onComplete: () => {
                    this.bigWinContainer.setInteractive({cursor: 'pointer'})
                        .once('pointerup', () => {
                            this.destroyBigWin(true);
                        });
                }
            });

            this.bigWinAmountContainer.setAlpha(1);
            this.incrementTo(this.request.scenario.total_prize);
        }
    }

    bigWinPositioner()
    {
        if (!this.bigWinContainer) {
            return;
        }

        this.bigWinContainer.x = this.cameras.main.centerX;
        this.bigWinContainer.y = this.cameras.main.centerY;
        this.bigWinContainer.setSize(this.cameras.main.width, this.cameras.main.height);

        this.bigWinAmountSubContainer.x = 0;
        this.bigWinAmountSubContainer.y = 0;

        if (this.bigWinText) {
            this.bigWinText.setY(this.bigWinText.y - this.bigWinText.height / 2)

            this.bigWinAmountContainer.setY(this.bigWinText.y + this.bigWinText.height / 2 + this.bigWinAmountContainer.displayHeight / 2 + 30);
        }
    }

    destroyBigWin(byHand)
    {
        if (this.bigWinDestroyed) {
            return;
        }

        this.pointCountSound.stop();
        this.stgBigWin.stop();
        this.batsSound.stop();

        this.bigWinDestroyed = true;

        this.customHelper.removeClickable(this.bigWinContainer);

        if (this.bigWinTimer) {
            this.bigWinTimer.remove();
        }

        this.bigWinEmitter.stop();

        /*this.tweens.add({
            targets: this.fullFaderMain,
            alpha: 0,
            ease: 'Power0',
            duration: 200,
            delay: (byHand ? 0 : 1500) + 200,
        });*/

        this.tweens.add({
            targets: [this.bigWinContainer],
            scale: 1.2,
            ease: 'Power0',
            duration: 200,
            delay: byHand ? 0 : 1500,
            onComplete: () => {
                this.bigWinParticle.destroy();

                this.tweens.add({
                    targets: [this.bigWinContainer],
                    scale: 0,
                    ease: 'Power0',
                    duration: 300,
                    onComplete: () => {
                        if (this.bigWinTween && this.bigWinTween.isPlaying()) {
                            this.bigWinTween.stop();
                            this.bigWinTween.remove();
                        }

                        if (this.bigWinTween2 && this.bigWinTween2.isPlaying()) {
                            this.bigWinTween2.stop();
                            this.bigWinTween2.remove();
                        }

                        if (this.bigWinContainer) {
                            this.bigWinContainer.destroy();
                        }

                        if (this.bigWinAmountContainer) {
                            this.bigWinAmountContainer.destroy();
                        }

                        if (this.bigWinAmountSubContainer) {
                            this.bigWinAmountSubContainer.destroy();
                        }

                        this.ticketFinished();
                    }
                });
            }
        });
    }

    incrementTo(winning)
    {
        let lastAmount = 0;
        let delay = 0;

        if (lastAmount === winning) {
            this.setAmountText(delay, winning, true, 1, callback)
        } else {
            if (!this.pointCountSound.isPlaying) {
                this.pointCountSound.play();
            }

            var incrementSize = winning / 45;

            if (incrementSize < 0.01) {
                incrementSize = 0.01;
            }

            if (parseFloat(incrementSize) > 1) {
                incrementSize = Math.ceil(incrementSize);
            }

            while (lastAmount !== winning) {
                lastAmount += incrementSize;

                if (lastAmount > winning) {
                    lastAmount = winning;
                }

                this.setAmountText(delay, lastAmount, lastAmount === winning)

                delay += 55;
            }
        }
    }

    setAmountText(delay, amount, last)
    {
        amount = General.format_currency(amount).replace(Config.currency.symbol, '');

        this.time.delayedCall(delay, () => {
            let scale = this.bigWinAmountContainer.scaleX;
            let x = this.bigWinAmountContainer.x;
            let y = this.bigWinAmountContainer.y;

            this.bigWinAmountContainer.destroy();

            if (this.bigWinDestroyed) {
                return;
            }

            this.bigWinAmountContainer = this.customHelper.createWinningFromSprites(amount, 1, '_win', 0)
                .setX(x)
                .setY(y)
                .setScale(scale);

            this.bigWinAmountSubContainer.add(this.bigWinAmountContainer);

            if (last) {
                this.pointCountSound.stop();
                this.sound.play('sfx_big_win_counter_loop_end');

                this.tweens.add({
                    targets: this.bigWinAmountContainer,
                    scale: 1.2,
                    ease: 'Power0',
                    duration: 100,
                    yoyo: true,
                    onComplete: () => {
                        this.destroyBigWin();
                    }
                });
            }
        }, this);
    }

    gamePositioner()
    {
        if (!this.spritesReady) {
            return;
        }

        if (this.bonusTweens) {
            for (let key in this.bonusTweens) {
                if (this.bonusTweens[key].isPlaying()) {
                    this.bonusTweens[key].complete();
                }
            }

            this.bonusTweens = [];
        }

        this.regularWinPositioner();
        this.bigWinPositioner();

        this.mainFrame.setX(0).setY(-(this.mainFrame.height / 2) - 150);
        this.luckySymbolsLabel.setX(0).setY(-525);
        this.yourSymbolsLabel.setX(0).setY(-260);

        if (this.orientationIsSetToPortrait()) {
            this.bg.setTexture('bg_portrait');
            this.bonusBg.setTexture('bonus_bg_portrait');
            this.mainGameGroup.currentOriginX = this.cameras.main.centerX;
            this.mainGameGroup.currentOriginY = this.cameras.main.centerY;

            this.frontDirt.setX(this.cameras.main.centerX).setY(this.cameras.main.height - 400);
            this.groundPortrait.setX(this.cameras.main.centerX).setY(this.cameras.main.height).setAlpha(1);
            this.logo.setX(this.cameras.main.centerX).setY(this.logo.height / 2 + 20);

            this.witch.setX(-150).setY(this.cameras.main.height + 170);

            this.couldronBase.setX(this.cameras.main.centerX + 30).setY((this.cameras.main.height - this.couldronBase.height / 2) + 100);
            this.smokeLoop.setScale(0.8);

            this.bonusContainer
                .setX(this.cameras.main.centerX)
                .setY(this.cameras.main.centerY);

            if (!this.bonusRunning) {
                this.mainGameGroup
                    .setX(this.mainGameGroup.currentOriginX)
                    .setY(this.mainGameGroup.currentOriginY);
            } else {
                this.mainGameGroup
                    .setX(this.mainGameGroup.currentOriginX)
                    .setY(this.cameras.main.height + this.mainFrame.height / 2 + 150);
            }

        } else {
            this.groundPortrait.setAlpha(0);
            this.bonusBg.setTexture('bonus_bg');
            this.mainGameGroup.currentOriginX = this.cameras.main.centerX;
            this.mainGameGroup.currentOriginY = this.cameras.main.centerY;

            this.bg.setTexture('bg');

            this.logo.setX(this.cameras.main.width - this.logo.width / 2 - 20).setY(this.logo.height / 2 + 20);

            this.witch.setX(0).setY(this.cameras.main.height);

            this.frontDirt.setX(this.cameras.main.centerX).setY(this.cameras.main.height - 10);

            this.couldronBase.setX(this.cameras.main.width - this.couldronBase.width / 2 - 40).setY(this.cameras.main.height - this.couldronBase.height / 2 - 30);

            this.smokeLoop.setScale(1);

            this.bonusContainer
                .setX(this.cameras.main.centerX)
                .setY(this.cameras.main.centerY);

            if (!this.bonusRunning) {
                this.mainGameGroup
                    .setX(this.mainGameGroup.currentOriginX)
                    .setY(this.mainGameGroup.currentOriginY);
            } else {
                this.mainGameGroup
                    .setX(this.mainGameGroup.currentOriginX)
                    .setY(this.cameras.main.height + this.mainFrame.height / 2 + 150);
            }
        }
        this.bonusBg
            .setX(this.cameras.main.centerX)
            .setY(this.cameras.main.centerY);

        this.frontContainerFader.setX(-(this.cameras.main.width/2)).setY(-(this.cameras.main.height/2));
        this.smokeLoop.setX(this.couldronBase.x).setY(this.couldronBase.y - this.smokeLoop.displayHeight / 2 - 80);

        this.couldronActivate.setX(this.couldronBase.x).setY(this.couldronBase.y - this.couldronActivate.height / 2 - 80);
        this.multiplier.setX(this.couldronBase.x).setY(this.couldronBase.y - this.multiplier.height / 2 - 120);
        this.couldronReveal.setX(this.couldronBase.x).setY(this.couldronBase.y - this.couldronReveal.height / 2 - 130);

        this.bg.setY(this.cameras.main.height);
    }

    properties()
    {
        this.mappedSymbolsNames = {
            1: 'clown',
            2: 'cyclop',
            3: 'frankenstein',
            4: 'ghost',
            5: 'mummy',
            6: 'scarecrow',
            7: 'skeleton',
            8: 'dracula',
            9: 'wolf',
            10: 'zombie'
        }
    }
}


class AnimatedParticle extends Phaser.GameObjects.Particles.Particle
{
    constructor (emitter)
    {
        super(emitter);

        this.t = 0;
        this.i = Math.floor(Math.random() * 7);
    }

    update (delta, step, processors)
    {
        var result = super.update(delta, step, processors);

        this.t += delta;

        if (this.t >= coinsAnim.msPerFrame) {
            this.i++;

            if (this.i > 7) {
                this.i = 0;
            }

            this.frame = coinsAnim.frames[this.i].frame;

            this.t -= coinsAnim.msPerFrame;
        }

        return result;
    }
}


class AnimatedParticleBat extends Phaser.GameObjects.Particles.Particle
{
    constructor (emitter)
    {
        super(emitter);

        this.t = 0;
        this.i = Math.floor(Math.random() * 5);
    }

    update (delta, step, processors)
    {
        var result = super.update(delta, step, processors);

        this.t += delta;

        if (this.t >= batAnim.msPerFrame) {
            this.i++;

            if (this.i > 5) {
                this.i = 0;
            }

            this.frame = batAnim.frames[this.i].frame;

            this.t -= batAnim.msPerFrame;
        }

        return result;
    }
}


startGame(GameScene);